import { imageAsset, fileVars, resourceData, manualResources } from "queries"

export const query = `{
  entries(section: "resource") {
    id
    title
    uri
    sectionHandle
    typeHandle
    ...on resource_Entry {
      resourceTag {
        id
        slug
        title
      }
      heading
      date
      image {
        ${imageAsset}
      }
      file {
        ${fileVars}
      }
      staffMember {
        id
        slug
        typeHandle
        title
      }
      relatedTag {
        id
        typeHandle
        slug
      }
    }
    ...on simpleResource_Entry {
      date
      image {
        ${imageAsset}
      }
      resourceTag {
        id
        slug
        title
      }
      relatedTag {
        id
        typeHandle
        slug
      }
      staffMember {
        id
        slug
        typeHandle
        title
      }
      resourceLink {
        ...on resourceLinkBlock_Entry {
          externalLink
          fileAsset {
            ${fileVars}
          }
        }
      }
    }
  }
}`

export const featuredResource = `query {
  entries(section: "resourcesIndex") {
    ...on resourcesIndex_Entry {
      id
      heading
    }
  }
}`

export const pageQuery = `
query($slug:[String]) {
  entries(section: "resource", slug: $slug) {
    id
    title
    slug
    uri
    typeHandle
    ...on resource_Entry {
      resourceTag {
        id
        slug
        title
      }
      heading
      date
      image {
        ${imageAsset}
      }
      file {
        ${fileVars}
      }
      staffMember {
        id
        slug
        typeHandle
        title
      }
      body
      embed
      relatedTag {
        ...on issueArea_Entry {
          id
          typeHandle
          slug
        }
      }
      ${manualResources}
    }
    ...on simpleResource_Entry {
      resourceLink {
        ...on resourceLinkBlock_Entry {
          externalLink
          fileAsset {
            ${fileVars}
          }
        }
      }
    }
  }
}`

export const allResources = `
query($id:QueryArgument,$relatedTo:[QueryArgument], $location: [QueryArgument]) {
  entries(section: "resource", id: [$id,"not 20257","not 20273","not 20276"], relatedTo: $relatedTo, locationTag: $location) {
    ${resourceData}
  }
}`

export const relatedQuery = `
query($relatedTo:[QueryArgument]) {
  entries(section: "resource", id: ["not 20257","not 20273","not 20276"], relatedTo: $relatedTo) {
    ${resourceData}
  }
}`

export const indexPage = `query {
  entries(section: "resourcesIndex") {
    ...on resourcesIndex_Entry {
      id
      heading
    }
  }
}`
